import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PermissionService } from '../_services';

/**
 * JS-1920 follow-up (2026-11-02): /agency-client/edit-templates is the client-portal
 * template library. Agency users reach it from /agency/edit-templates (already behind
 * AgencyGuard) and never hit this one. Client users land here from the sidebar + Edit
 * Templates tab on their own profile — gate it on the "Edit Templates" perm.
 *
 * Agency users pass through unconditionally (they manage templates agency-wide; the
 * perm is a client-settings-only toggle). Unauthenticated → /login. Unauthorized client
 * user → /self-service/projects (their natural home), falling back to /client-dashboard.
 */
@Injectable({ providedIn: 'root' })
export class EditTemplatesGuard implements CanActivate {
  constructor(private router: Router, private permissionService: PermissionService) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
    if (!currentUser) {
      return of(this.router.createUrlTree(['/login']));
    }

    // Agency users (no client_id on the session) are never gated by this perm.
    if (!currentUser.client_id) {
      return of(true);
    }

    return this.permissionService.canAccessFunctionality('Edit Templates').pipe(
      map((allowed: boolean) => {
        if (allowed) {
          return true;
        }
        return this.router.createUrlTree(['/self-service/projects']) as UrlTree;
      }),
      catchError(() => of(this.router.createUrlTree(['/client-dashboard']) as UrlTree))
    );
  }
}
